import React from 'react';

import type { ButtonProps } from '@mui/material';
import { Button as MUIButton, styled } from '@mui/material';

export interface LookoButtonInternalProps extends Pick<ButtonProps, 'type' | 'children'> {
  /**
   * 텍스트.
   *
   * @deprecated children 으로 써주세요.
   */
  text?: string;

  /**
   * 비활성화 여부
   */
  disabled?: boolean;

  /**
   * 크기
   * @default 'medium'
   */
  size?: 'small' | 'medium' | 'large';

  /**
   * 버튼 너비 크기.
   *
   * @default 'default'
   */
  widthSize?: 'default' | 'small' | 'full';
}

export const lookoButtonHeight: Record<NonNullable<LookoButtonInternalProps['size']>, number> = {
  small: 28,
  medium: 32,
  large: 40,
};

/**
 * 버튼 Base.
 */
export const LookoButtonInternal = styled(
  React.forwardRef<HTMLButtonElement, ButtonProps & LookoButtonInternalProps>(
    ({ widthSize = 'default', ...props }, ref) => <MUIButton ref={ref} fullWidth={widthSize === 'full'} {...props} />,
  ),
)(({ size = 'medium', widthSize = 'default' }) => {
  return {
    height: `${lookoButtonHeight[size]}px`,
    width: widthSize === 'small' ? '160px' : undefined,
    fontWeight: size === 'large' ? 700 : 500,
  };
}) as typeof MUIButton;
